import type { SupportedLocalesKeys } from 'utils/translations/translations';
import { localeCodes } from 'utils/translations/translations';

export function useLocales(): SupportedLocalesKeys[] {
  return localeCodes as SupportedLocalesKeys[];
}
